<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="$t('Modify') + ' ' + $t('a.device')"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <b-form @submit.stop.prevent="onSubmit">
          <b-form-group
              id="type-input"
              :label="$t('device.Type')+'*'"
              label-for="type-input"
              class="bold-label col-12"
              :invalid-feedback="form.type.invalidFeedback"
              :state="form.type.state"
          >
            <b-form-select
              id="type-input"
              v-model="form.type.value"
              :options="deviceTypes"
              :state="form.type.state"
              required
            ></b-form-select>
          </b-form-group>

          <b-form-group
              id="brand-input"
              :label="$t('device.Brand')+'*'"
              label-for="brand-input"
              class="bold-label col-12"
              :invalid-feedback="form.brand.invalidFeedback"
              :state="form.brand.state"
          >
            <b-form-input
                id="brand-input"
                :placeholder="$t('device.Brand')"
                v-model="form.brand.value"
                type="text"
                maxlength="250"
                :state="form.brand.state"
                required
            ></b-form-input>
          </b-form-group>

          <b-form-group
              id="model-input"
              :label="$t('device.Model')"
              label-for="model-input"
              class="bold-label col-12"
              :invalid-feedback="form.model.invalidFeedback"
              :state="form.model.state"
          >
            <b-form-input
                id="model-input"
                :placeholder="$t('device.Model')"
                v-model="form.model.value"
                type="text"
                maxlength="250"
                :state="form.model.state"
            ></b-form-input>
          </b-form-group>

          <b-form-group
              id="serialNumber-input"
              :label="$t('device.SerialNumber')"
              label-for="serialNumber-input"
              class="bold-label col-12"
              :invalid-feedback="form.serialNumber.invalidFeedback"
              :state="form.serialNumber.state"
          >
            <b-form-input
                id="serialNumber-input"
                :placeholder="$t('device.SerialNumber')"
                v-model="form.serialNumber.value"
                type="text"
                maxlength="250"
                :state="form.serialNumber.state"
            ></b-form-input>
          </b-form-group>

          <b-form-group
              id="year-input"
              :label="$t('device.Year')"
              label-for="year-input"
              class="bold-label col-12"
              :invalid-feedback="form.year.invalidFeedback"
              :state="form.year.state"
          >
            <b-form-input
                id="year-input"
                :placeholder="$t('device.Year')"
                v-model="form.year.value"
                type="text"
                maxlength="250"
                :state="form.year.state"
            ></b-form-input>
          </b-form-group>

          <b-form-group
              id="power-input"
              :label="$t('device.Power')"
              label-for="power-input"
              class="bold-label col-12"
              :invalid-feedback="form.power.invalidFeedback"
              :state="form.power.state"
          >
            <b-form-input
                id="power-input"
                :placeholder="$t('device.Power')"
                v-model="form.power.value"
                type="text"
                maxlength="250"
                :state="form.power.state"
            ></b-form-input>
          </b-form-group>


          <date-field
              :is-required="false"
              :dateName="$t('device.LastMaintenance')"
              @dateInfos="getLastMaintenanceDateInfos"
              :init-value=initValueLastMaintenanceDate
          >
          </date-field>

          <div class="col-12">
            <SelectAutoCompleteField
              class="ml-0"
              :title="$t('intervention.AddressIntervention')+'*'"
              :urlData="'/addressIntervention/getSuggestions?word='"
              @setTagValue="setAddressIntervention"
              :initValue="addressIntervention"
            >
            </SelectAutoCompleteField>
          </div>

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import DateField from "../../components/b122/DateField";
import SelectAutoCompleteField from "../../components/SelectAutoCompleteField";

export default {

  name: 'DeviceEdit',

  components: {
    BackArrow,
    DateField,
    SelectAutoCompleteField
  },

  data() {
    return {
      deviceId: this.$route.params.deviceId,
      clientName: this.$route.params.clientName,
      addressIntervention: null,
      initValueLastMaintenanceDate: null,
      deviceTypes: [],
      form: {
        brand:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        lastMaintenance:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        model:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        power:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        serialNumber:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        type:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        year:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        addressIntervention:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },

      }
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.fetchDevice()
    },

    fetchDevice() {
      api
          .get(`/device/${this.deviceId}`)
          .then(response => {
            this.device = response.data
            this.fetchDeviceTypes()
          })
    },

    fetchDeviceTypes(){
      api
        .get(`/device/getDeviceTypes`)
        .then(response => {
          this.deviceTypes.push({value: null, text: this.$i18n.t('TypeSelect'), disabled: true})
          response.data.map(deviceType => {
            this.deviceTypes.push({value: deviceType.id, text: deviceType.name})
          })
          this.setInitialValues()
        })
    },

    setInitialValues() {
      this.form.brand.value = this.device.brand
      this.form.model.value = this.device.model
      this.form.power.value = this.device.power
      this.form.serialNumber.value = this.device.serialNumber
      this.form.type.value = this.device.type.id
      this.form.year.value = this.device.year
      this.addressIntervention = this.device.addressIntervention
      if(this.device.lastMaintenance !== undefined && this.device.lastMaintenance !== null){
        this.initValueLastMaintenanceDate = new Date(this.device.lastMaintenance)
      }
    },

    getLastMaintenanceDateInfos(state, invalidFeedBack, value) {
      this.form.lastMaintenance.state = state;
      this.form.lastMaintenance.invalidFeedback = invalidFeedBack;
      this.form.lastMaintenance.value = value;
    },

    onSubmit() {
      let data = new FormData()
      data.append('type', this.form.type.value)
      data.append('brand', this.form.brand.value)

      if(!this.addressIntervention){
        return
      }
      data.append('addressInterventionId', this.addressIntervention.id)

      if (this.form.lastMaintenance.value) {
        data.append('lastMaintenance', new Date( this.form.lastMaintenance.value).getTime())
      }
      if (this.form.model.value && this.form.model.value.trim() !== "") {
        data.append('model', this.form.model.value)
      }
      if (this.form.power.value && this.form.power.value.trim() !== "") {
        data.append('power', this.form.power.value)
      }
      if (this.form.serialNumber.value && this.form.serialNumber.value.trim() !== "") {
        data.append('serialNumber', this.form.serialNumber.value)
      }
      if (this.form.year.value && this.form.year.value.trim() !== "") {
        data.append('year', this.form.year.value)
      }

      api({
        method: 'POST',
        url: `/device/${this.device.id}`,
        data: data
      })
          .then((response) => {
            this.$router.push({
              name: 'DeviceShow',
              params: {
                deviceId: this.device.id,
                clientName: this.clientName
              }
            }, () => {
              this.$nextTick(() => {
                this.successToast()
              })
            })
          })
          .catch((error) => {
            if (error.response.status === 418) {
              const invalidField = error.response.data.invalidField
              this.form[invalidField]["state"] = false
              this.form[invalidField]["invalidFeedback"] = error.response.data.message
            }
          });
    },

    successToast(deviceName) {
      this.$bvToast.toast(this.$i18n.t('Device') + ' ' + this.$i18n.t('modify'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    setAddressIntervention(addressIntervention){
      this.addressIntervention=addressIntervention
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/device/DeviceEdit.vue